module.exports = __webpack_public_path__ + "media/images/shopify_faq_3-0282dd80d7aae2ef52d02b81135f4790.png";